import { useState, useEffect } from "react";
import { PermissionEnum, User } from "TypesAndInterfaces";

const usePermission = (permission: PermissionEnum) => {
  const [isAuthorized, setIsAuthorized] = useState(true);

  useEffect(() => {
    const userString = localStorage.getItem("user");
    if (userString) {
      const user: User = JSON.parse(userString);
      if (!user.permissions.includes(permission)) {
        setIsAuthorized(false);
      }
    }
  }, [permission]);

  return { isAuthorized };
};
export default usePermission;
